import CardInvestBerkala from "./CardInvestBerkala";
export default CardInvestBerkala;
